// extracted by mini-css-extract-plugin
export default {"long-ap":"LongAp_long-ap__I0IDU","announce":"LongAp_announce__sSOZE"};